<template>
  <toggle-details data-open-on-init="true">
    <div slot-scope="{ opened, toggle }" class="enhancements-overview">
      <!-- TODO: A11y replace aria-label with dictionary item -->
      <div
        role="button"
        class="activator"
        v-on:click="toggle"
        v-on:enter="toggle"
        v-on:space.prevent="toggle"
        aria-label="Toggle details"
        v-bind:aria-expanded="opened ? 'true' : 'false'"
      >
        <div class="enhancements-overview-title">{{tc('booking.complementaryPrivilages')}}</div>
      </div>
      <transition name="expand-y">
        <div v-if="opened" class="cart-enhancements-list">
          <div
            v-for="enhancement in enhancementsInRoom"
            :key="enhancement.sitecoreID"
            class="cart-enhancement"
          >
            <div class="enhancement-title">
              {{enhancement.enhancement.name}}
            </div>
            <div
              v-if="enhancement.summary"
              class="enhancement-summary section-label"
              v-html="enhancement.summary"
            />
          </div>
        </div>
      </transition>
    </div>
  </toggle-details>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'room-enhancements-overview',
  props: {
    roomIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('i18n', ['tc']),
    ...mapGetters('cart', ['getEnhancementsInRoom']),
    ...mapGetters('auth', ['enhancementsAllowed']),
    enhancementsInRoom() {
      return this.getEnhancementsInRoom(this.roomIndex)
    }
  }
}
</script>
